import { Card } from "@/components/ui/card";
import { Info } from "lucide-react";

interface CampaignFAQProps {
  className?: string;
}

export default function CampaignFAQ({ className }: CampaignFAQProps) {
  const faqs = [
    {
      question: "What happens when I enroll in a campaign?",
      answer:
        "When you click \"Get Started,\" it just tells the brand you're open to working with them. It doesn't lock you into anything. You'll get access to the campaign dashboard where you can see what other creators are making and start planning your own content.",
    },
    {
      question: "Do I have to create content right away?",
      answer:
        "Nope! You can browse ideas, get inspired, and decide later if you want to upload. You're free to back out anytime, there's zero obligation.",
    },
    {
      question: "Do I need approval or to sign anything?",
      answer:
        "There's no approval process and no contracts required to join a campaign. Once enrolled, you can start uploading videos on the platform whenever you're ready. Brands then approve the video uploads and you can start posting them on social media!",
    },
    {
      question: "What if I change my mind?",
      answer: "Totally fine. You don't have to post anything.",
    },
    {
      question: "How do I get paid?",
      answer:
        "You'll just need to connect your Stripe account (it only takes a few minutes). You can do this at anytime from the settings page. You will be prompted to do this before you publish your first video on social media. After the campaign ends, payouts are processed within 14 days. We'll notify you as soon as your payment is on the way.",
    },
    {
      question: "Can I see examples of what other creators made?",
      answer:
        "Yes! After enrolling, you'll land on a dashboard showing real examples from other creators and curated by the brand. It's just inspiration, you don't need to match their style.",
    },
  ];

  return (
    <Card className={`p-6 space-y-6 ${className || ""}`}>
      <div className="text-center">
        <h3 className="text-xl font-semibold text-primary mb-2">
          🤔 Still unsure? Here's what most creators ask before enrolling.
        </h3>
      </div>

      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div key={index} className="space-y-2">
            <div className="flex items-start gap-3">
              <span className="text-lg font-semibold text-primary/80 flex-shrink-0">
                {index + 1}️⃣
              </span>
              <div className="space-y-2">
                <h4 className="font-medium text-primary text-sm">
                  {faq.question}
                </h4>
                <p className="text-sm text-primary/70 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex items-start space-x-2 p-3 bg-blue-50 dark:bg-blue-950/20 rounded-lg">
        <Info className="h-4 w-4 text-blue-500 mt-0.5 flex-shrink-0" />
        <div className="text-xs text-blue-700 dark:text-blue-300">
          <p className="font-medium mb-1">Need more help?</p>
          <p>
            If you have any other questions, feel free to reach out to our
            support team. We're here to help you succeed!
          </p>
        </div>
      </div>
    </Card>
  );
}
